import PrivacyPolicyPage from 'features/privacy-policy'

export const privacyPolicyRoutes = [
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />
  }
]
